const GenerateReport = () => import("./views/GenerateReport.vue");
const AllReports = () => import("./views/AllReports.vue");
export default [
  {
    path: "generate",
    name: "generate-hrm-report",
    component: GenerateReport,
  },
  {
    path: "all",
    name: "hrm-view-reports",
    component: AllReports,
  },
];
